// extracted by mini-css-extract-plugin
export var bounce = "newsletter-pop-module--bounce--G2g0J";
export var newsletterPop = "newsletter-pop-module--newsletterPop--BZWjn";